// extracted by mini-css-extract-plugin
export var container = "ImageTile-module--container--2GRPi";
export var title = "ImageTile-module--title--1WXWF";